<template>
    <!-- 添加平台公告弹框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogAddEditNoticeVisible" width="60%" @close="dialogClose"
               top="4vh"
               :modal-append-to-body="false"
               append-to-body>
        <tinymce v-if="dialogAddEditNoticeVisible" ref="tinymce" v-model="formAddNotice.content" :height="500" class="add-notice-row" />
<!--        <el-row type="flex">-->
<!--            <el-upload class="upload-container" ref="uploadMultiple" :action="action" :on-remove="handleRemove"-->
<!--                       :on-success="handleSuccess" :headers="customHeaders" style="margin-left: 10px;"-->
<!--                       name="multipartFile" multiple :show-file-list="false">-->
<!--                <el-button size="small" type="primary">上传附件</el-button>-->
<!--            </el-upload>-->
<!--        </el-row>-->
<!--        <div style="margin: 10px 0;" v-for="(item, index) in formAddNotice.accessoryList" :key="index">-->
<!--            {{ `${ index + 1 }. ${ item.accessoryName }` }}-->
<!--        </div>-->
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogAddEditNoticeVisible = false">取 消</el-button>
            <el-button type="primary" @click="updateNoticeSave" :loading="loadingStatus === 'updateNoticeSave'">保 存
            </el-button>
        </div>
    </el-dialog>
</template>
<script>
    import Tinymce from "@/components/Tinymce";
    import { ajaxPost, Baseurl } from "@/api/api/api";
    export default {
        name: 'fuwenbenComp',
        components: {
            Tinymce,
        },
        data() {
            return {
                dialogTitle:'尺码编辑',
                dialogAddEditNoticeVisible: false,
                formAddNotice: {
                    title: "",
                    content: "",
                    accessoryList: [],
                },
                action: Baseurl + "imageController/uploadFile",
                customHeaders: { token: localStorage.getItem("token") },
                loadingStatus: "",
                type:''
            }
        },
        created() {
        },
        // mounted() {
        // 	//鼠标悬浮在图表上有 中文提示
        // 	const titleConfig = [
        // 		{ Choice: ".ql-insertMetric", title: "跳转配置" },
        // 		{ Choice: ".ql-bold", title: "加粗" },
        // 		{ Choice: ".ql-italic", title: "斜体" },
        // 		{ Choice: ".ql-underline", title: "下划线" },
        // 		{ Choice: ".ql-header", title: "段落格式" },
        // 		{ Choice: ".ql-strike", title: "删除线" },
        // 		{ Choice: ".ql-blockquote", title: "块引用" },
        // 		{ Choice: ".ql-code", title: "插入代码" },
        // 		{ Choice: ".ql-code-block", title: "插入代码段" },
        // 		{ Choice: ".ql-font", title: "字体" },
        // 		{ Choice: ".ql-size", title: "字体大小" },
        // 		{ Choice: '.ql-list[value="ordered"]', title: "编号列表" },
        // 		{ Choice: '.ql-list[value="bullet"]', title: "项目列表" },
        // 		{ Choice: ".ql-direction", title: "文本方向" },
        // 		{ Choice: '.ql-header[value="1"]', title: "h1" },
        // 		{ Choice: '.ql-header[value="2"]', title: "h2" },
        // 		{ Choice: ".ql-align", title: "对齐方式" },
        // 		{ Choice: ".ql-color", title: "字体颜色" },
        // 		{ Choice: ".ql-background", title: "背景颜色" },
        // 		{ Choice: ".ql-image", title: "图像" },
        // 		{ Choice: ".ql-video", title: "视频" },
        // 		{ Choice: ".ql-link", title: "添加链接" },
        // 		{ Choice: ".ql-formula", title: "插入公式" },
        // 		{ Choice: ".ql-clean", title: "清除字体格式" },
        // 		{ Choice: '.ql-script[value="sub"]', title: "下标" },
        // 		{ Choice: '.ql-script[value="super"]', title: "上标" },
        // 		{ Choice: '.ql-indent[value="-1"]', title: "向左缩进" },
        // 		{ Choice: '.ql-indent[value="+1"]', title: "向右缩进" },
        // 		{ Choice: ".ql-header .ql-picker-label", title: "标题大小" },
        // 		{ Choice: '.ql-header .ql-picker-item[data-value="1"]', title: "标题一" },
        // 		{ Choice: '.ql-header .ql-picker-item[data-value="2"]', title: "标题二" },
        // 		{ Choice: '.ql-header .ql-picker-item[data-value="3"]', title: "标题三" },
        // 		{ Choice: '.ql-header .ql-picker-item[data-value="4"]', title: "标题四" },
        // 		{ Choice: '.ql-header .ql-picker-item[data-value="5"]', title: "标题五" },
        // 		{ Choice: '.ql-header .ql-picker-item[data-value="6"]', title: "标题六" },
        // 		{ Choice: ".ql-header .ql-picker-item:last-child", title: "标准" },
        // 		{ Choice: '.ql-size .ql-picker-item[data-value="small"]', title: "小号" },
        // 		{ Choice: '.ql-size .ql-picker-item[data-value="large"]', title: "大号" },
        // 		{
        // 			Choice: '.ql-size .ql-picker-item[data-value="huge"]',
        // 			title: "超大号",
        // 		},
        // 		{ Choice: ".ql-size .ql-picker-item:nth-child(2)", title: "标准" },
        // 		{ Choice: ".ql-align .ql-picker-item:first-child", title: "居左对齐" },
        // 		{
        // 			Choice: '.ql-align .ql-picker-item[data-value="center"]',
        // 			title: "居中对齐",
        // 		},
        // 		{
        // 			Choice: '.ql-align .ql-picker-item[data-value="right"]',
        // 			title: "居右对齐",
        // 		},
        // 		{
        // 			Choice: '.ql-align .ql-picker-item[data-value="justify"]',
        // 			title: "两端对齐",
        // 		},
        // 		{ Choice: ".ql-upload", title: "上传文件" },
        // 		{ Choice: ".ql-table", title: "插入表格" },
        // 		{ Choice: ".ql-table-insert-row", title: "插入行" },
        // 		{ Choice: ".ql-table-insert-column", title: "插入列" },
        // 		{ Choice: ".ql-table-delete-row", title: "删除行" },
        // 		{ Choice: ".ql-table-delete-column", title: "删除列" },
        // 	];
        //
        // 	for (let item of titleConfig) {
        // 		let tip = document.querySelector(".quill-editor " + item.Choice);
        // 		if (!tip) continue;
        // 		tip.setAttribute("title", item.title);
        // 	}
        //
        // 	// 自定义字体大小
        // 	const Size = Quill.import("attributors/style/size");
        // 	Size.whitelist = ["10px", "12px", "16px", "18px", "20px", "30px", "32px"];
        // 	Quill.register(Size, true);
        //
        // 	// 自定义字体类型
        // 	var fonts = [
        // 		"SimSun",
        // 		"SimHei",
        // 		"Microsoft-YaHei",
        // 		"KaiTi",
        // 		"FangSong",
        // 		"Arial",
        // 		"sans-serif",
        // 	];
        // 	var Font = Quill.import("formats/font");
        // 	Font.whitelist = fonts;
        // 	Quill.register(Font, true);
        // 	this.$nextTick(() => {
        //
        // 		this.$refs.myQuillEditor.quill.enable(true);
        //
        // 		// this.$refs.myQuillEditor.quill.blur();
        //
        // 		// this.$refs.myQuillEditor.quill.focus();
        //
        // 		this.$refs.myQuillEditor.quill.setSelection(this.content.length);
        //
        // 	});
        // },
        methods: {
            initContent(val,type){
                this.dialogAddEditNoticeVisible = true
                this.type = type
                if (type == 'tuwen'){
                    this.dialogTitle = '图文编辑'
                } else {
                    this.dialogTitle = '尺码编辑'
                }
                if (val){
                    this.$nextTick(() => {
                        this.formAddNotice.content = val
                        // this.$refs.tinymce.setContent(val);
                    });
                }
            },
            handleSuccess(response, file, fileList) {
                const { code, data } = response;
                if (code === 200) {
                    const { fileName, accessoryUrl, uploadTime } = data
                    const obj = {
                        accessoryName: fileName,
                        accessoryUrl: accessoryUrl,
                        uploadTime: uploadTime,
                    };
                    this.formAddNotice.accessoryList.push(obj);
                } else {
                    this.$message.error(data)
                }
            },
            handleRemove(file) {
                const { name, id } = file;
                const arr1 = this.formAddNotice.accessoryList;
                for (let i = 0, len = arr1.length; i < len; i++) {
                    if (arr1[i].accessoryName === name) {
                        arr1.splice(i, 1);
                        break;
                    }
                }
                this.removeFile(id);
            },

            removeFile(id) {
                const API = Baseurl + "accessoryController/deleteAccessory";
                const paramsData = { accessoryId: id };
                ajaxPost(API, paramsData).then(res => {
                    const { data: { code } } = res;
                    if (code === 200) {
                        this.$message.success("操作成功");
                        this.getListTable();
                    } else {
                        this.$message.error("操作失败");
                    }
                });
            },
            updateNoticeSave() {
                this.$emit('changeContent',this.type,this.formAddNotice.content)
                this.dialogClose()

            },
            dialogClose() {
                this.dialogAddEditNoticeVisible = false
                this.formAddNotice = {
                    title: "",
                    content: "",
                    accessoryList: [],
                };
                this.$refs.tinymce.setContent("");
            },
        }
    }
</script>

<style lang="scss" scoped>
    .addInformation {
        width: 98%;
        overflow: hidden;
        padding-bottom: 72px;

        .pagination-container {
            width: 1660px;
            padding: 20px;
            position: fixed;
            right: 0;
            bottom: 0;
            background: #fff;
            z-index: 999;

            .el-pagination {
                display: flex;
                justify-content: center;
            }
        }

        .add-notice-row {
            margin-bottom: 10px;

            .title {
                flex-shrink: 0;
                margin-right: 10px;
            }
        }

        .upload-container {
            width: 40%;
        }

        ::v-deep {
            .notice-content {
                img {
                    max-width: 100%;
                }
            }
        }
    }
</style>
